import inboxIcon from '../../assets/images/forgotPasswordFormInbox.png'
import inboxIcon2x from '../../assets/images/forgotPasswordFormInbox@2x.png'

export interface InboxIconProps {
  size?: number
  className?: string
}

/**
 * Inbox Icon Component
 *
 * Displays the inbox icon for password reset success screen from Figma design.
 * Automatically uses @2x version for high-DPI displays.
 *
 * @example
 * <InboxIcon size={100} />
 *
 * @example
 * <InboxIcon size={64} className="my-custom-class" />
 */
export function InboxIcon({ size = 100, className = '' }: InboxIconProps) {
  return (
    <img
      src={inboxIcon}
      srcSet={`${inboxIcon} 1x, ${inboxIcon2x} 2x`}
      alt="Inbox"
      width={size}
      height={size}
      className={className}
    />
  )
}
